import './rainbowcone/style';
import FormStructure from './rainbowcone/form_structure';

export default FormStructure;